module.exports = __webpack_public_path__ + "media/images/featured-qbo-8455d5fe808e37ce82915d60b46c70cf.png";